



















































import { Component, Vue, Watch } from "vue-property-decorator";
import { esSearch } from "@/req/home";
import qs from "@/components/queSheng.vue";
@Component({
  components: {
    qs,
  },
})
export default class Home extends Vue {
  public activeMenu = "";
  public typeStatus: any = "";
  public list = [];
  public game: any = "原始传奇_2";
  public timer: any = null;

  public mounted() {
    if (this.$route.query.game) {
      this.game = this.$route.query.game;
    }
    this.getList();
    this.toTimer();
  }
  //   @Watch("this.$route.query.game") public addd(val) {
  //     console.log(val);
  //   }
  public updated() {
    if (this.$route.query.game != this.game) {
      this.game = this.$route.query.game;
      this.getList();
    }
  }
  public destroyed() {
    clearTimeout(this.timer);
  }
  public toTimer() {
    this.timer = setTimeout(() => {
      if (this.$route.query.game != this.game) {
        this.game = this.$route.query.game;
        this.getList();
      }
      this.toTimer();
    }, 1000);
  }
  public async getList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      search_info: this.game,
    };
    const res = await esSearch(obj);
    if (res.code == 200) {
      this.list = res.data.searchResult;
      if (this.list.length == 0) {
        this.typeStatus = 1;
      }
    }
  }
  // 标签
  public toTags(list) {
    if (list == "") {
      return [];
    }
    if (Array.isArray(list)) {
      return list;
    }
    const arr = list.split("|");
    return arr;
  }
  // 匹配搜索关键字
  public handleGameName(name) {
    let content = name;
    // 匹配关键字正则
    const replaceReg = new RegExp(this.game, "g");
    // const replaceString = "<span color='#c18f3a'>" + this.game + "</span>";
    const replaceString = `<span style="color: #c18f3a">${this.game}</span>`;
    if (!content) {
      return "";
    }
    if (this.game && this.game.length > 0) {
      // 开始替换
      content = content.replace(replaceReg, replaceString);
    }
    return content;
  }
  public getClear() {
    this.$router.push("/home");
  }
  //   // 替换匹配的文字
  //   contentSearch(value, array) {
  //     let arrayContent = array;
  //     // 匹配关键字正则
  //     let replaceReg = new RegExp(value, "g");
  //     // 高亮替换v-html值
  //     let replaceString = '<span class="search-text">' + value + "</span>";
  //     for (let i = 0; i < arrayContent.length; i++) {
  //       let titleString = arrayContent[i];
  //       if (!titleString.name) {
  //         return "";
  //       }
  //       if (value && value.length > 0) {
  //         // 开始替换
  //         titleString.name = titleString.name.replace(replaceReg, replaceString);
  //       }
  //     }
  //     // 深拷贝的方法
  //   }
}
